/**
 * @description 页面埋点配置注册表（与需求文档事件名对齐）
 */

/** @type {Record<string, Object>} */
export const PAGE_TRACKING = {
  websiteHome: {
    pageKey: 'pv_Homepage_page',
    pvEvent: 'pv_Homepage',
    pageName: '官网首页',
    targetType: 'homepage',
    targetId: 'homepage',
    targetName: '官网首页',
  },
  mallHome: {
    pageKey: 'pv_MallHomepage_page',
    pvEvent: 'pv_MallHomepage',
    pageName: '商城首页',
    targetType: 'mall_homepage',
    targetId: 'mall_homepage',
    targetName: '商城首页',
  },
  mallList: {
    pageKey: 'pv_MallList_page',
    pvEvent: 'pv_MallList',
    pageName: '商城列表页',
    targetType: 'mall_list',
    targetId: 'mall_list',
    targetName: '商城列表页',
  },
  productDetail: {
    pageKey: 'pv_ProductDetailPage_page',
    pvEvent: 'pv_ProductDetailPage',
    pageName: '商品详情页',
    targetType: 'product_detail',
    targetId: 'product_detail',
    durationPvEvent: 'pv_ProductDetailPage_Duration',
  },
  cart: {
    pageKey: 'pv_Cart_page',
    pvEvent: 'pv_Cart',
    pageName: '购物车',
    targetType: 'cart',
    targetId: 'cart',
    targetName: '购物车',
    durationPvEvent: 'pv_Cart_Duration',
  },
  confirmPage: {
    pageKey: 'pv_ConfirmPage_page',
    pvEvent: 'pv_ConfirmPage',
    pageName: '订单确认页',
    targetType: 'confirm_page',
    targetId: 'confirm_page',
    targetName: '订单确认页',
    durationPvEvent: 'pv_ConfirmPage_Duration',
  },
  activityPage: {
    pageKey: 'pv_ActivityPage_page',
    pvEvent: 'pv_ActivityPage',
    pageName: '活动聚合页',
    targetType: 'activity_page',
    targetId: 'activity_page',
    targetName: '活动聚合页',
    durationPvEvent: 'pv_ActivityPage_Duration',
  },
  schemeHome: {
    pageKey: 'pv_Scheme_page',
    pvEvent: 'pv_Scheme',
    pageName: '方案首页',
    targetType: 'scheme_home',
    targetId: 'scheme_home',
    targetName: '方案首页',
  },
  schemeList: {
    pageKey: 'pv_SchemeList_page',
    pvEvent: 'pv_SchemeList',
    pageName: '方案列表页',
    targetType: 'scheme_list',
    targetId: 'scheme_list',
    targetName: '方案列表页',
  },
  schemeDetail: {
    pageKey: 'pv_SchemeDetailPage_page',
    pvEvent: 'pv_SchemeDetailPage',
    pageName: '方案详情页',
    targetType: 'scheme_detail',
    targetId: 'scheme_detail',
    durationPvEvent: 'pv_SchemeDetailPage_Duration',
  },
  caseDetail: {
    pageKey: 'pv_CaseDetailPage_page',
    pvEvent: 'pv_CaseDetailPage',
    pageName: '案例详情页',
    targetType: 'case_detail',
    targetId: 'case_detail',
    durationPvEvent: 'pv_CaseDetailPage_Duration',
  },
  technicalSupport: {
    pageKey: 'pv_TechnicalSupport_page',
    pvEvent: 'pv_TechnicalSupport',
    pageName: '技术支持',
    targetType: 'technical_support',
    targetId: 'technical_support',
    targetName: '技术支持',
  },
  downloadCenter: {
    pageKey: 'pv_DownloadCenter_page',
    pvEvent: 'pv_DownloadCenter',
    pageName: '下载中心',
    targetType: 'download_center',
    targetId: 'download_center',
    targetName: '下载中心',
  },
  helpCenter: {
    pageKey: 'pv_HelpCenter_page',
    pvEvent: 'pv_HelpCenter',
    pageName: '帮助中心',
    targetType: 'help_center',
    targetId: 'help_center',
    targetName: '帮助中心',
  },
  joinIn: {
    pageKey: 'pv_JoinIn_page',
    pvEvent: 'pv_JoinIn',
    pageName: '我要入住首页',
    targetType: 'join_in',
    targetId: 'join_in',
    targetName: '我要入住首页',
    durationPvEvent: 'pv_JoinIn_Duration',
  },
}

/**
 * @description 根据分类埋点前缀生成分类首页配置
 * @param {string} prefix - 如 HomeNetwork / EnterpriseNetwork
 * @param {string} categoryId
 * @param {string} categoryName
 * @returns {Object}
 */
export function buildCategoryPageTracking(prefix, categoryId, categoryName) {
  return {
    pageKey: `pv_${prefix}_page_${categoryId}`,
    pvEvent: `pv_${prefix}`,
    pageName: categoryName || prefix,
    targetType: `${prefix.toLowerCase()}_homepage`,
    targetId: String(categoryId || prefix),
    targetName: categoryName || prefix,
    properties: {
      category_id: String(categoryId || ''),
      category_name: categoryName || '',
    },
  }
}

/**
 * @description 生成分类首页 Banner 埋点配置
 * @param {string} prefix
 * @param {string} pageName
 * @returns {Object}
 */
export function buildCategoryBannerTracking(prefix, pageName) {
  return {
    pvEvent: `pv_${prefix}_Banner`,
    clickEvent: `pv_${prefix}_Banner_click`,
    pageName,
    targetType: `${prefix.toLowerCase()}_banner`,
  }
}

/**
 * @description 生成 Header 悬停浮层埋点配置
 * @param {string} prefix
 * @param {string} categoryId
 * @param {string} categoryName
 * @returns {Object}
 */
export function buildHoverPageTracking(prefix, categoryId, categoryName) {
  return {
    pageKey: `pv_${prefix}_Hover_page_${categoryId}`,
    pvEvent: `pv_${prefix}_Hover`,
    pageName: `${categoryName}悬浮页`,
    targetType: `${prefix.toLowerCase()}_hover`,
    targetId: String(categoryId || prefix),
    targetName: categoryName || String(categoryId || prefix),
    properties: {
      category_id: String(categoryId || ''),
      category_name: categoryName || '',
    },
  }
}
